import { render, staticRenderFns } from "./SubmissionIndex.vue?vue&type=template&id=67fa3098"
import script from "./SubmissionIndex.vue?vue&type=script&lang=js"
export * from "./SubmissionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports